import UseTips from './useTips';

export default {
  UseTips,
};
